import { string } from "yup";

const obj = {
  field: [
    {
      title: "Topic or Keyword",
      attr: "content",
      value: "",
      id: "topic",
      placeholder: "Keyword List",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string()
        .nullable()
        .trim("Initially whitespace are not allowed")
        .required("Topic or Keyword is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],

  example: [
    {
      title: "Topic or Keyword",
      attr: "content",
      value: "Football",
      id: "topic",
      placeholder: "Keyword List",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string()
        .nullable()
        .trim("Initially whitespace are not allowed")
        .required("Topic or Keyword for PPC is Required"),

      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
  ],

  editor: {
    output: `-Football\n-Gridiron\n-Pigskin\n-End Zone\n-Touchdown\n-Quarterback\n-Offense\n-Defense\n-Receiver\n-Running Back\n-Field Goal\n-Lineman\n-Huddle `,
  },
};

export default obj;
